import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen: React.FC = () => {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-8"
      >
        <div className="flex items-center gap-4">
          {/* Favicon icon */}
          <svg viewBox="0 0 64 64" width="48" height="48">
            <rect x="2" y="2" width="60" height="60" rx="12" fill="#1F2937"/>
            <rect x="12" y="28" width="4" height="8" rx="2" fill="#10B981"/>
            <rect x="19" y="22" width="4" height="20" rx="2" fill="#10B981"/>
            <rect x="26" y="18" width="4" height="28" rx="2" fill="#10B981"/>
            <rect x="33" y="24" width="4" height="16" rx="2" fill="#10B981"/>
            <rect x="40" y="20" width="4" height="24" rx="2" fill="#10B981"/>
            <rect x="47" y="26" width="4" height="12" rx="2" fill="#10B981"/>
            <circle cx="54" cy="12" r="5" fill="#10B981"/>
            <path d="M54 9 v6 M51 12 h6" stroke="#1F2937" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          {/* Wordmark */}
          <svg viewBox="0 0 200 50" height="40" fill="none">
            <defs>
              <linearGradient id="loadingLogoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#00f0ff"/>
                <stop offset="100%" stopColor="#00d4e0"/>
              </linearGradient>
              <linearGradient id="loadingAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ff00aa"/>
                <stop offset="100%" stopColor="#ff66cc"/>
              </linearGradient>
            </defs>
            <text x="0" y="38" fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" fontSize="40" fontWeight="700" letterSpacing="-1">
              <tspan fill="url(#loadingLogoGradient)">NaLi</tspan><tspan fill="url(#loadingAccentGradient)">Vox</tspan>
            </text>
          </svg>
        </div>
      </motion.div>

      {/* Loading bar */}
      <div className="loading-bar">
        <motion.div
          className="loading-bar-fill"
          initial={{ width: '0%' }}
          animate={{ width: '100%' }}
          transition={{ duration: 1.8, ease: 'easeInOut' }}
        />
      </div>

      {/* Loading text */}
      <motion.p
        className="mt-6 text-xs uppercase tracking-[0.3em] text-gray-500"
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{ duration: 1.5, repeat: Infinity }}
      >
        Loading Experience
      </motion.p>
    </motion.div>
  );
};

export default LoadingScreen;
